import request from '@/utils/http'
import { SRM, SRM_FILE } from '../constant/constant.js'

// 查询
export const getAssessmentPage = data => {
    return request({
        url: `${SRM}/supplierMonthlyAssessmentPage`,
        method: 'post',
        data,
    })
}

// 编辑
export const editAssessment = data => {
    return request({
        url: `${SRM}/supplierMonthlyAssessmentEdit`,
        method: 'post',
        data,
    })
}

// 添加发文
export const addNoticeUrl = data => {
    return request({
        url: `${SRM}/monthlyAssessmentAddNoticeUrl`,
        method: 'post',
        data,
    })
}

//  导入
export const importAssessment = data => {
    return request({
        headers: { 'Content-Type': 'multipart/form-data' },
        url: `${SRM_FILE}/importMonthlyAssessment`,
        method: 'post',
        data,
    })
}

// 导出
export const exportAssessment = data => {
    return request({
        url: `${SRM_FILE}/exportMonthlyAssessment`,
        method: 'post',
        data,
    })
}

// 获取冻结开关状态
export const getImportFlag = data => {
    return request({
        url: `${SRM}/getAssessmentOpenImportFlag`,
        method: 'get',
        params: data,
    })
}

// 更换冻结开关状态
export const switchImportFlag = data => {
    return request({
        url: `${SRM}/switchAssessmentOpenImportFlag`,
        method: 'get',
        params: data,
    })
}
